module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-19-84afa0cf3be7ce008ae766b6bb1896b5.png";